import cn from 'classnames'; // 또는 clsx 등 선호하는 클래스네임 유틸리티
import { motion } from 'framer-motion';

const loadingContainerVariants = {
  start: {
    transition: {
      staggerChildren: 0.2,
    },
  },
  end: {
    transition: {
      staggerChildren: 0.2,
    },
  },
};

const loadingDotVariants = {
  start: {
    opacity: 0.2,
  },
  end: {
    opacity: 1,
  },
};

const loadingDotTransition = {
  duration: 0.5,
  repeat: Infinity,
  repeatType: 'reverse' as const,
  ease: 'easeInOut',
};

const LoadingDotsFramer = () => {
  const dotClasses = cn('size-2 rounded-full bg-primary-050');

  return (
    <motion.div
      className='relative flex h-5 items-center justify-center gap-1'
      variants={loadingContainerVariants}
      initial='start'
      animate='end'
    >
      <motion.div
        className={dotClasses}
        variants={loadingDotVariants}
        transition={loadingDotTransition}
      />
      <motion.div
        className={dotClasses}
        variants={loadingDotVariants}
        transition={loadingDotTransition}
      />
      <motion.div
        className={dotClasses}
        variants={loadingDotVariants}
        transition={loadingDotTransition}
      />
    </motion.div>
  );
};

export default LoadingDotsFramer;
